import { isEmpty } from 'lodash';
import { useContext } from 'react';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { useCardFormContext } from '@shared/components/blocks/contexts/form';
import { MBIconV2 } from '@shared/components/image';
import { ColorThemeContext, grid } from '@shared/styles';
import { i18n } from '@shared/util/i18n';

export function FormErrorBanner() {
  const colors = useContext(ColorThemeContext);
  const { errors } = useCardFormContext();
  const hasErrors = !isEmpty(errors);

  if (!hasErrors) {
    return null;
  }

  return (
    <View row centerVertically paddingHorizontal={3} paddingVertical={1}>
      <MBIconV2 name="exclamation-filled" size={grid(3)} color={colors.error.foreground} />
      <View flex paddingLeft={1}>
        <Text size="body2" danger>
          {i18n('card.form.errorBanner')}
        </Text>
      </View>
    </View>
  );
}
